window.LoopService = window.LoopService || {};

window.LoopService.Wallet = {
  /**
   * Get wallet balance and expiry information
   */
  getBalanceAndExpiry: async (shopifyCustomerId) => {
    try {
      if (!shopifyCustomerId) {
        throw new Error("getBalanceAndExpiry: missing shopifyCustomerId");
      }

      const baseUrl = window.LoopService.Base.getDigitalOceanBaseUrl();
      const url = `${baseUrl}/customer/${shopifyCustomerId}/wallet`;

      const response = await window.LoopService.Base.makeAuthenticatedRequest(
        url,
        {
          method: "GET",
        }
      );

      const { data } = await response.json();

      // Calculate expiration date count
      const expirationDateCount = data.expirationDate
        ? Math.ceil(
            (new Date(data.expirationDate) - new Date()) / (1000 * 60 * 60 * 24)
          )
        : null;

      return {
        balance: +data.balance || 0,
        expirationDate: data.expirationDate,
        expirationDateCount,
      };
    } catch (error) {
      console.error("Wallet balance fetch failed:", error);
      return {
        balance: 0,
        expirationDate: null,
        expirationDateCount: null,
      };
    }
  },

  getAllowedProductsForWallet: async () => {
    //   const productIds =
    //     (await window.LoopService.WalletData.getAllowedProducts()) || [];
    //   return productIds;
    // },
    try {
      await window.ClerkUtils.waitForClerk();

      const baseUrl = window.LoopService.Base.getDigitalOceanBaseUrl();
      const country = window.Shopify.country;
      const url = `${baseUrl}/loop/wallet/upsell-products/country/${country}`;

      const response = await window.LoopService.Base.makeAuthenticatedRequest(
        url,
        {
          method: "GET",
        }
      );

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Allowed products fetch failed:", error);
      return [];
    }
  },
};

// window.LoopService.WalletData = (function () {
//   let _state = {
//     loaded: false,
//     loadingPromise: null,
//     error: null,
//     wallet: null, // { balance, expirationDate, expirationDateCount }
//     allowedProductIds: null, // []
//   };

//   const load = async () => {
//     if (_state.loadingPromise) return _state.loadingPromise;
//     if (_state.loaded) return _state;

//     _state.loadingPromise = (async () => {
//       try {
//         const baseUrl = window.LoopService.Base.getDigitalOceanBaseUrl();
//         const customerId = window.Shopify?.customerId;
//         const country = window.Shopify?.country;

//         if (!customerId) {
//           throw new Error("WalletData.load: missing Shopify customerId");
//         }
//         if (!country) {
//           throw new Error("WalletData.load: missing Shopify country");
//         }

//         const walletUrl = `${baseUrl}/customer/${customerId}/wallet`;
//         const allowedUrl = `${baseUrl}/loop/wallet/upsell-products/country/${country}`;

//         const [walletRes, allowedRes] = await Promise.all([
//           window.LoopService.Base.makeAuthenticatedRequest(walletUrl, {
//             method: "GET",
//           }),
//           window.LoopService.Base.makeAuthenticatedRequest(allowedUrl, {
//             method: "GET",
//           }),
//         ]);

//         const [{ data: walletData }, allowedData] = await Promise.all([
//           walletRes.json(),
//           allowedRes.json(),
//         ]);

//         const expirationDateCount = walletData.expirationDate
//           ? Math.ceil(
//               (new Date(walletData.expirationDate) - new Date()) /
//                 (1000 * 60 * 60 * 24)
//             )
//           : null;

//         _state.wallet = {
//           balance: +walletData.balance || 0,
//           expirationDate: walletData.expirationDate,
//           expirationDateCount,
//         };

//         _state.allowedProductIds = allowedData || [];
//         _state.error = null;
//         _state.loaded = true;

//         return _state;
//       } catch (err) {
//         console.error("[WalletData] failed to load:", err);
//         _state.error = err;
//         _state.loaded = false;
//         _state.wallet = {
//           balance: 0,
//           expirationDate: null,
//           expirationDateCount: null,
//         };
//         _state.allowedProductIds = [];
//         return _state;
//       } finally {
//         _state.loadingPromise = null;
//       }
//     })();

//     return _state.loadingPromise;
//   };

//   const getWallet = async () => {
//     const state = await load();
//     return state.wallet;
//   };

//   const getAllowedProducts = async () => {
//     const state = await load();
//     return state.allowedProductIds;
//   };

//   // Em caso de ações que mudem wallet (usar crédito, etc)
//   const invalidate = () => {
//     _state = {
//       loaded: false,
//       loadingPromise: null,
//       error: null,
//       wallet: null,
//       allowedProductIds: null,
//     };
//   };

//   return {
//     load,
//     getWallet,
//     getAllowedProducts,
//     invalidate,
//   };
// })();
